import React, { useEffect, useState } from "react";
import AddBonus from './add-bonus';
import EditBonus from './edit-bonus';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';



export default function Bonuses() {
    const [addBonusOpen, setAddBonusOpen] = useState(false);
    const [editBonusOpen, setEditBonusOpen] = useState(false);
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [workerFilter, setWorkerFilter] = useState("all");
    const [bonusCategoryFilter, setBonusCategoryFilter] = useState("all");
    const [editedBonusId, setEditedBonusId] = useState("");
    const [availableWorkers, setAvailableWorkers] = useState([]);
    const [bonusesList, setBonusesList] = useState([]);
    const api_url = process.env.REACT_APP_API_URL;
    const complexName = localStorage.getItem('complex_name');
    const [totalBonuses, setTotalBonuses] = useState(0);                        //всего премий
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const handleAddBonusOpen = () => setAddBonusOpen(true);
    const handleAddBonusClose = () => setAddBonusOpen(false);

    const handleEditBonusOpen = () => setEditBonusOpen(true);
    const handleEditBonusClose = () => setEditBonusOpen(false);

    function showEditBonusModal(Bonus_id){
        handleEditBonusOpen();
        setEditedBonusId(Bonus_id);
    }


    function showAddBonusModal(){
        handleAddBonusOpen();
    }

    React.useEffect(() => {                                         //функция, которая вызывается при загрузке страницы
        async function getAvailableWorkers() {      //получаем список всех доступных сотрудников
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
              body: JSON.stringify({ complex_name: complexName })
            };
            const availableWorkers = await (await fetch(api_url+"/api/allLiveWorkers", requestOptions)).json();
            setAvailableWorkers(availableWorkers.map(({worker_id, full_name, rank, phone_number, complex_name, role}) => ({workerId: worker_id, fullName: full_name, rank: rank, phoneNumber: phone_number, complexName: complex_name, role: role})));
        }
    
        async function getBonuses() {
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')},
            body: JSON.stringify({ start_date: startDate, end_date: endDate, worker_id: workerFilter, complex_name: complexName, bonus_category: bonusCategoryFilter})
          };
          setLoading(true);
          try {
            const bonuses_list = await fetch(api_url+"/api/allBonuses", requestOptions);
            const body = await bonuses_list.json();
            setBonusesList(body.map(({ bonus_id, bonus_date, worker_id, full_name, bonus_amount, complex_name, comment, bonus_category, created_by }) => ({ bonus_id: bonus_id, bonus_date: new Date(bonus_date).toLocaleString("ru-RU", { timeZone: "UTC" }), worker_id: worker_id, worker_name: full_name, bonus_amount: bonus_amount, complex_name: complex_name, comment: comment, bonus_category: bonus_category, created_by: created_by })));
            let temp_total_bonuses = 0;

            for(var i=0; i < body.length; i++){
               temp_total_bonuses = temp_total_bonuses + body[i].bonus_amount;
            }

            setTotalBonuses(temp_total_bonuses);
          } finally {
            setLoading(false);
          }
        }
        getAvailableWorkers();
        getBonuses();
    
        }, [startDate, endDate, workerFilter, addBonusOpen, editBonusOpen, bonusCategoryFilter]);

    return (
        <>
            <Box sx={{pt:5, pb:5}} fullWidth>
            <TextField
                id="start_date"
                label="Дата с"
                type="date"
                defaultValue={startDate}
                sx={{ m: 1.5, width: 220}}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => { setStartDate(e.target.value); setPage(0); }}
            />

            <TextField
                id="end_date"
                label="Дата по"
                type="date"
                defaultValue={endDate}
                sx={{ m: 1.5, width: 220 }}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => { setEndDate(e.target.value); setPage(0); }}
            />

            <FormControl sx={{m: 1.5, width: 250}} >
            <InputLabel id="demo-simple-select-label">Категория премии</InputLabel>
            <Select
                id="bonus_category"
                value={bonusCategoryFilter}
                label="Категория премии"
                onChange={e => { setBonusCategoryFilter(e.target.value); setPage(0); }}
            >
            <MenuItem value="all">Все премии</MenuItem>
            <MenuItem value="regular_bonus">Обычная премия</MenuItem>
            <MenuItem value="birthday_bonus">Премия за ДР</MenuItem>
            <MenuItem value="annual_bonus">Годовая премия</MenuItem>
            </Select>
            </FormControl>

            <FormControl sx={{m: 1.5, width: 250}} >
            <InputLabel id="demo-simple-select-label">Выберите сотрудника</InputLabel>
            <Select
                id="worker_name"
                value={workerFilter}
                label="Выберите сотрудника"
                onChange={e => { setWorkerFilter(e.target.value); setPage(0); }}
            >
            <MenuItem value="all">Любой</MenuItem>
            {availableWorkers.map((item) => (
            <MenuItem key={item.workerId} value={item.workerId}>{item.fullName}</MenuItem>
            ))}
            </Select>
            </FormControl>
            </Box>

            <button className='add-visit-button' onClick={() => showAddBonusModal()}>
                <a>Добавить премию</a>
            </button>

            <Typography m={5} variant="h6">Премии за выбранный период: {totalBonuses} </Typography>

            <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="bonuses table">
            <TableHead>
            <TableRow>
                <TableCell>Дата</TableCell>
                <TableCell>Сотрудник</TableCell>
                <TableCell align="right">Размер премии</TableCell>
                <TableCell>Категория премии</TableCell>
                <TableCell>Комментарий</TableCell>
                <TableCell>Добавил</TableCell>
                <TableCell></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {loading ? (
                <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6 }}><CircularProgress size={28} /></TableCell>
                </TableRow>
            ) : bonusesList.length === 0 ? (
                <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6, color: 'text.secondary' }}>Нет премий за выбранный период</TableCell>
                </TableRow>
            ) : bonusesList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(({bonus_date, bonus_id, worker_name, bonus_amount, bonus_category, comment, created_by}) => (
            <TableRow key={bonus_id} hover>
                <TableCell>{bonus_date}</TableCell>
                <TableCell>{worker_name}</TableCell>
                <TableCell align="right">{bonus_amount}</TableCell>
                <TableCell>
                {bonus_category === 'regular_bonus' ? 'Обычная премия' : bonus_category === 'annual_bonus' ? 'Годовая премия' : bonus_category === 'birthday_bonus' ? 'Премия за ДР' : 'Неизвестная категория'}
                </TableCell>
                <TableCell sx={{whiteSpace: "normal", wordWrap: "break-word"}}>{comment}</TableCell>
                <TableCell>{created_by || '-'}</TableCell>
                <TableCell>
                <Button
                    variant="outlined"
                    onClick={() => showEditBonusModal(bonus_id)}>Изменить</Button>
                </TableCell>
            </TableRow>
            ))}
            </TableBody>
            </Table>
            </TableContainer>
            {!loading && bonusesList.length > 0 && (
            <TablePagination
                component="div"
                count={bonusesList.length}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Строк на странице:"
            />
            )}

            <Modal
            open={addBonusOpen}
            onClose={handleAddBonusClose}
            >
            <AddBonus availableWorkers={availableWorkers}/>
            </Modal>

            <Modal
            open={editBonusOpen}
            onClose={handleEditBonusClose}
            >
            <EditBonus editedBonusId={editedBonusId} availableWorkers={availableWorkers}/>
            </Modal>
        </>
    )
}

